import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconStarComponent } from "./med-icon-star.component";

@NgModule({
  declarations: [
    MedIconStarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconStarComponent,
  ],
})
export class MedIconStarModule { }
